import React, { useMemo, useContext, useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { MediaGalleryDesktop } from '@thd-olt-component-react/media-gallery';
import { propTypes } from './VendorCollectionPropTypes';
import {
  AvailableOptionsTabs,
  VendorCollectionDescription,
  VendorCollectionTitle
} from './subcomponents';
import './vendor-collection.scss';
import { VendorCollectionDataModel } from './VendorCollectionDataModel';
import { VendorCollectionSection } from './subcomponents/VendorCollectionSection';
import { getVendorCollectionBreadCrumbs } from './BreadCrumbsGenerator';

export const VendorCollectionDesktop = ({
  collectionName,
  onChange
}) => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('vendorCollection.ready');
  }, []);

  const {
    data: vendorCollectionData,
    error: vendorCollectionError,
    loading: vendorCollectionLoading
  } = useDataModel('fetchCollectionsContent', {
    variables: { collectionName },
    ssr: true
  });

  const { fetchCollectionsContent } = vendorCollectionData || {};
  const {
    media,
    title,
    brand,
    availableOptions,
    section,
    description
  } = fetchCollectionsContent || {};

  useEffect(() => {
    if (!vendorCollectionLoading) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('vendorCollections.data', { fetchCollectionsContent });
    }
  }, [vendorCollectionLoading]);

  const vendorCollectionSections = useMemo(
    () => section?.map((sect) => <VendorCollectionSection section={sect} key={sect.title} />),
    [section]
  );
  const { path } = useContext(ExperienceContext);

  if ((vendorCollectionLoading && !vendorCollectionData?.fetchCollectionsContent) || vendorCollectionError) {
    return null;
  }

  return (
    <Row className="vendor-collection" data-component="VendorCollectionDesktop">
      <Col>
        <Breadcrumbs staticCrumbs={getVendorCollectionBreadCrumbs(path)} />
      </Col>
      <Col className="sui-p-0">
        <div className="sui-grid sui-grid-cols-1 lg:sui-grid-cols-5 sui-gap-4 sui-p-2">
          {media && (
            <div className="sui-col-span-3 sui-bg-primary sui-rounded-base sui-pt-3 sui-pl-1 sui-pr-1">
              <VendorCollectionTitle
                className="vendor-collection__title--tablet"
                name={title}
                brandName={brand}
              />
              <MediaGalleryDesktop overrideData={{ media, brandNameLabel: brand, galleryLabel: title }} />
            </div>
          )}
          <div className="sui-col-span-2 sticky sui-bg-primary sui-rounded-base sui-pt-3 sui-pl-1 sui-pr-1">
            <VendorCollectionTitle
              className="vendor-collection__title--desktop"
              name={title}
              brandName={brand}
            />
            <AvailableOptionsTabs
              collectionName={collectionName}
              onChange={onChange}
              availableOptions={availableOptions || []}
              channel="desktop"
            />
            <VendorCollectionDescription description={description} />
          </div>
        </div>
        {vendorCollectionSections}
        <BackToTop />
      </Col>
    </Row>
  );
};

VendorCollectionDesktop.displayName = 'VendorCollectionDesktop';

VendorCollectionDesktop.dataModel = VendorCollectionDataModel;

VendorCollectionDesktop.propTypes = propTypes;
